import { extensionPrefs } from "../prefs";

function create(extensionId, projectId, defaultValues = {}) {
    return {
        get(name) {
            return extensionPrefs.get(extensionId, projectId, name).then(function (value) {
                if (value === null || typeof value === "undefined") {
                    return defaultValues[name];
                }

                return value;
            });
        },
        getAll() {
            return extensionPrefs.get(extensionId, projectId).then(function (storedPrefs) {
                return Object.assign({}, defaultValues, storedPrefs);
            });
        },
        set(name, value) {
            return extensionPrefs.set(extensionId, projectId, name, value);
        }
    };
}

function clear(extensionId) {
    return extensionPrefs.remove(extensionId);
}

const extensionStorage = {
    create,
    clear
};

export default extensionStorage;
